export const lang = {
  title: '睿连智行',
  download: '点击下载'
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js